import { LibService } from './libService';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { UserSessionService } from './user-session.service';
import { GuardService } from './guard.service';
import { AuthService } from '../auth/auth.service'

@Injectable({
  providedIn: 'root'
})
export class PecService extends BaseService {

  constructor(
    public LibService: LibService,
    public AuthService: AuthService,
    public userSessionService: UserSessionService,
    public guardService: GuardService
  ) {
    super(LibService, AuthService)
    this.baseApi = environment.rootApiCrm + 'v1.0/';
    this.model = 'pecs'
  }

  allWithPagination(filterOptions: any = [], orderOptions: any = [], skip: number = 0, take: number = 10) {
    console.log("allWithPagination")
    let skipOption = skip || 0;
    let takeOption = take || 10;

    let options = {
      filters: filterOptions,
      order: orderOptions,
      skip: skipOption,
      take: takeOption
    }
    return this.libService.postDataWithAccessToken<any>(this.tokenId, options, this.baseApi, `${this.model}/withPagination`);
  }

  history(id: number, filterOptions: any = [], orderOptions: any = [], skip: number = 0, take: number = 10) {
    console.log("history")
    let skipOption = skip || 0;
    let takeOption = take || 10;

    let options = {
      filters: filterOptions,
      order: orderOptions,
      skip: skipOption,
      take: takeOption
    }

    return this.libService.postDataWithAccessToken<any>(this.tokenId, options, this.baseApi, `${this.model}/${id}/history`);
  }

  removePecsAssociation(id: number, pecIdToRemove: number) {
    console.log("removePecsAssociation")
    return this.libService.deleteDataWithAccessToken<any>(this.tokenId, {}, this.baseApi, `${this.model}/${id}/removePecsAssociation/${pecIdToRemove}`);
  }

  addPecsAssociation(id: number, pecIdToAdd: number) {
    console.log("addPecsAssociation")
    return this.libService.postDataWithAccessToken<any>(this.tokenId, {}, this.baseApi, `${this.model}/${id}/addPecsAssociation/${pecIdToAdd}`);
  }



  

}










